module.exports = __webpack_public_path__ + "img/petImage.e2840fac.svg";